import { useAppContext } from "./useAppContext";

export const useGoogleAnalytics = () => {
	const { googleAnalytics } = useAppContext();

	return googleAnalytics;
};
